<template>
  <div class="page-head">
    <div class="title">
      <img v-if="isLogo" class="logo" src="../../assets/images/logo.png" alt />
      <img v-else class="customer-logo" src="../../assets/images/customer/logo.png" alt />
      <p v-if="isLogo" class="name">水晶系统</p>
    </div>
    <div class="breadcrumb-user">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <template v-for="(value, index) in breadcrumbList">
            <el-breadcrumb-item
              v-if="index === 0 || index === breadcrumbList.length - 1"
              :key="index"
              >{{ value.name }}</el-breadcrumb-item
            >
            <el-breadcrumb-item v-else :to="{ path: value.url }" :key="index">
              {{ value.name }}
            </el-breadcrumb-item>
          </template>
        </el-breadcrumb>
      </div>
      <div class="user">
        <div class="user-message">
          <p class="message">
            <svg
              class="svg"
              viewBox="0 0 1024 1024"
              version="1.1"
              p-id="8505"
              width="22"
              height="22"
            >
              <path
                d="M510.839002 2.321995C227.555556 2.321995 0 229.877551 0 513.160998s227.555556 510.839002 510.839002 510.839002 510.839002-227.555556 510.839003-510.839002-227.555556-510.839002-510.839003-510.839003z m0 248.453515c65.015873 0 116.099773 51.0839 116.099774 116.099773s-51.0839 116.099773-116.099774 116.099774-116.099773-51.0839-116.099773-116.099774 51.0839-116.099773 116.099773-116.099773zM255.419501 773.22449c0-167.183673 88.235828-222.911565 255.419501-222.911565s255.419501 55.727891 255.419501 222.911565H255.419501z"
                p-id="8506"
                fill="#2E68EA"
              />
            </svg>
            <span>{{ username }}</span>
          </p>
          <div class="account">
            <ul class="account-list">
              <li class="account-li" v-if="1 > 2">
                <svg
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="3440"
                  width="16"
                  height="16"
                >
                  <path
                    d="M505.034014 880.036281c-34.829932 0-65.015873 27.863946-65.015873 65.015873 0 34.829932 27.863946 65.015873 65.015873 65.015873s65.015873-27.863946 65.015873-65.015873c0-37.151927-30.185941-65.015873-65.015873-65.015873z m0 0"
                    fill="#666666"
                    p-id="3441"
                  />
                  <path
                    d="M799.927438 596.752834c67.337868-88.235828 92.879819-202.013605 65.015873-313.469387-37.151927-148.60771-160.217687-257.741497-308.825397-278.639456C328.562358-23.219955 135.836735 150.929705 135.836735 371.519274c0 81.269841 27.863946 160.217687 76.62585 225.23356C91.718821 694.276644 19.736961 842.884354 19.736961 1003.102041c0 11.609977 9.287982 18.575964 18.575964 18.575964h44.117914c11.609977 0 18.575964-6.965986 20.897959-18.575964 4.643991-58.049887 30.185941-239.165533 176.471656-341.333334l11.609977 11.609978c62.693878 44.117914 139.319728 69.659864 213.623583 69.659864 76.62585 0 153.251701-25.54195 213.623582-67.337869l11.609978-11.609977c146.285714 104.489796 171.827664 283.283447 176.471655 341.333333 0 11.609977 9.287982 18.575964 20.897959 18.575964h44.117914c11.609977 0 18.575964-9.287982 18.575964-18.575964 0-164.861678-69.659864-313.469388-190.403628-408.671202zM505.034014 650.15873c-153.251701 0-278.639456-125.387755-278.639456-278.639456s125.387755-278.639456 278.639456-278.639455 278.639456 125.387755 278.639455 278.639455-125.387755 278.639456-278.639455 278.639456z"
                    fill="#666666"
                    p-id="3442"
                  />
                </svg>
                <span>我的账号</span>
              </li>
              <li class="account-li" @click="logout">
                <svg
                  class="icon"
                  viewBox="0 0 1026 1024"
                  version="1.1"
                  p-id="3167"
                  width="16.03125"
                  height="16"
                >
                  <path
                    d="M933.309207 772.654545h-83.781818c-4.654545 0-11.636364 2.327273-13.963636 6.981819-79.127273 97.745455-197.818182 153.6-323.490909 151.272727-111.709091 0-218.763636-44.218182-297.890909-123.345455-39.563636-37.236364-69.818182-83.781818-90.763637-132.654545-20.945455-51.2-32.581818-107.054545-32.581818-162.909091 0-111.709091 44.218182-218.763636 123.345455-297.890909 79.127273-79.127273 186.181818-123.345455 297.890909-123.345455 125.672727 0 244.363636 55.854545 323.490909 151.272728 4.654545 4.654545 9.309091 6.981818 13.963636 6.981818h83.781818c6.981818 0 11.636364-9.309091 6.981818-13.963637C847.200116 88.436364 684.291025 0 509.745571 0 374.763753 0 242.109207 55.854545 146.691025 153.6 51.272844 249.018182-2.254429 381.672727 0.072844 516.654545 2.400116 798.254545 230.472844 1024 512.072844 1024c174.545455 0 337.454545-88.436364 430.545454-235.054545 2.327273-2.327273 2.327273-6.981818 0-9.309091-2.327273-4.654545-4.654545-6.981818-9.309091-6.981819z"
                    p-id="3168"
                    fill="#666666"
                  />
                  <path
                    d="M1019.418298 505.018182L851.854662 372.363636c-2.327273-2.327273-6.981818-2.327273-9.309091 0-2.327273 2.327273-4.654545 4.654545-4.654546 9.309091v90.763637H465.527389c-2.327273 0-4.654545 0-6.981818 2.327272-2.327273 2.327273-2.327273 4.654545-2.327273 6.981819v67.490909c0 4.654545 4.654545 9.309091 9.309091 9.309091h372.363636v90.763636c0 6.981818 9.309091 11.636364 16.29091 6.981818l167.563636-132.654545c2.327273-2.327273 4.654545-4.654545 4.654545-6.981819-2.327273-6.981818-4.654545-9.309091-6.981818-11.636363z"
                    p-id="3169"
                    fill="#666666"
                  />
                </svg>
                <span>退出登录</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deleteToken, getDBUserRealName } from "common/js/storage";
import User from "models/user";
const user = new User();
export default {
  props: {
    isLogo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      username: "",
      breadcrumbList: []
    };
  },
  created() {
    this.username = getDBUserRealName();
    let arr = [];
    this.$route.matched.map((value, index) => {
      if (index > 0) {
        let obj = {};
        if (value.meta.menuName) {
          obj.url = value.path;
          if (value.path == '/base-info/project-manage/project-list/add-project') {
            if (this.$route.query.isFlag == 2) {
              obj.name = '编辑项目';
            } else if (this.$route.query.isFlag == 3) {
              obj.name = '项目详情';
            } else {
              obj.name = '新增项目';
            }
          } else {
            obj.name = value.meta.menuName;
          }
          arr.push(obj);
        }
      }
    });
    this.breadcrumbList = arr;
  },
  watch: {
    $route: {
      handler(newVal) {
        let arr = [];
        newVal.matched.map((value, index) => {
          if (index > 0) {
            let obj = {};
            if (value.meta.menuName) {
              obj.url = value.path;
              if (value.path == '/base-info/project-manage/project-list/add-project') {
                if (this.$route.query.isFlag == 2) {
                  obj.name = '编辑项目';
                } else if (this.$route.query.isFlag == 3) {
                  obj.name = '项目详情';
                } else {
                  obj.name = '新增项目';
                }
              } else {
                obj.name = value.meta.menuName;
              }
              arr.push(obj);
            }
          }
        });
        this.breadcrumbList = arr;
      }
    }
  },
  methods: {
    logout() {
      if (this.isLogo) {
        user.postUserLogout().then(res => {
          if (res.success) {
            deleteToken();
            this.$router.push("/login");
          }
        });
      } else {
        user.postCustomerUserLogout().then(res => {
          if (res.success) {
            deleteToken();
            this.$router.push("/customers-login");
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page-head {
  height: 80px;
  background: #fff;
  line-height: 80px;
  color: #fff;
  display: flex;
  z-index: 3;
  box-shadow: 0px 3px 12px 0px rgba(51, 51, 51, 0.06);
  .title {
    font-size: 20px;
    width: 200px;
    text-align: center;
    line-height: 80px;
    color: #2e68ea;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: hidden;
    .logo {
      width: 44px;
      height: 44px;
      margin-right: 10px;
    }
  }
  .customer-logo {
    width: 96px;
    height: 40px;
  }
  .breadcrumb-user {
    flex: 1;
    padding: 0 35px 0 20px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .breadcrumb {
      width: 400px;
    }
    .user {
      height: 80px;
      position: relative;
      .user-message {
        height: 80px;
        display: flex;
        align-items: center;
        .message {
          width: 154px;
          display: flex;
          align-items: center;
          font-size: 16px;
          line-height: 22px;
          color: #333;
          .svg {
            width: 22px;
            height: 22px;
            margin-right: 5px;
          }
        }
      }
      .account {
        z-index: 100;
        position: absolute;
        display: none;
        top: 80px;
        left: 0px;
        padding-top: 5px;
        .account-list {
          background: rgba(255, 255, 255, 1);
          box-shadow: 2px 2px 4px 3px rgba(51, 51, 51, 0.08);
          border-radius: 8px;
          width: 154px;
          height: 40px;
          .account-li {
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            color: #333;
            font-size: 16px;
            display: flex;
            align-items: center;
            .icon {
              margin-right: 15px;
            }
          }
        }
      }
    }
    .user:hover {
      cursor: pointer;
      .account {
        display: block;
      }
    }
  }
}
</style>
